import { formatNumber } from "@/lib/format-datetime";
import type { JudgeVerdict } from "@/features/quiz/coding-task-api";

/**
 * `EX-RTW04`: a test a partial-points checker scored above nothing and below
 * full. The server keeps `share` only on such a `wrong_answer` row, so every
 * other row (and every row of a problem without the switch) draws as before.
 * A share of 0 is a plain wrong answer.
 */
export function partialShareOf(row: { verdict: JudgeVerdict; share?: number }): number | null {
  if (row.verdict !== "wrong_answer" || typeof row.share !== "number") return null;
  return row.share > 0 && row.share < 1 ? row.share : null;
}

/** "50%", "33.3%" ("৫০%" on /bn), never more precise than one place. */
export function formatShare(share: number, locale: string): string {
  return formatNumber(share, locale, { style: "percent", maximumFractionDigits: 1 });
}
